import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ModalButtonClose } from "../generic/common/ModalButtonClose";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TransparentDialogWrapper } from "../transparent-dialog/TransparentDialogWrapper";
var _PromoteMobile = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(TransparentDialogWrapper, null,
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement("div", { className: "promote-mobile__dialog-wrapper" },
                React.createElement("div", { className: "flex flex--stacked__reverse flex--bottom" },
                    React.createElement("div", { className: "promote-mobile__qr-code" }),
                    React.createElement("div", { className: IdStyles.MobilePromoBackground + "\n                            promote-mobile__content\n                         flex flex--guts flex--stacked flex--top" },
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: IdLoca.mobilePromotionDialogueA_desc_web })),
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: IdLoca.mobilePromotionDialogueB_desc_web })),
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: IdLoca.mobilePromotionDialogueC_desc_web }))),
                    React.createElement("div", { className: "promote-mobile__title flex flex--end flex--aligned" },
                        React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                            React.createElement(TextLoca, { id: IdLoca.mobilePromotionDialogue_title_web })),
                        React.createElement(ModalButtonClose, { className: "promote-mobile__close-btn", onClick: function () { return onClose(IdModal.PromoteMobile); } })),
                    React.createElement("div", { className: "promote-mobile__rita" }))))));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: actionModalClose,
    }, dispatch);
};
export var PromoteMobile = connect(undefined, mapDispatch)(_PromoteMobile);



//////////////////
// WEBPACK FOOTER
// ./src/features/promote-mobile/promoteMobile.tsx
// module id = 2884
// module chunks = 3